import React from "react";
import {
  ArrowUpRight,
  BarChart3,
  Briefcase,
  Calculator,
  ShieldCheck,
} from "lucide-react";
import "./TpcTrainerJacquesSpotlight.css";

import jacquesImage from "../../images/Jacques01.webp";

const proofPoints = [
  {
    id: "experience",
    value: "20+",
    label: "Years in finance, investment and strategy",
    trend: "gold",
    icon: Briefcase,
  },
  {
    id: "jse",
    value: "JSE",
    label: "MBA research on return dispersion",
    trend: "green",
    icon: BarChart3,
  },
  {
    id: "model",
    value: "R12.8B",
    label: "Financial model supporting major deal structuring",
    trend: "red",
    icon: Calculator,
  },
];

const tradingFocus = [
  "Market efficiency",
  "Risk-adjusted decisions",
  "Capital allocation",
  "Financial modelling",
];

const marketCandles = [
  "green",
  "red",
  "green",
  "gold",
  "green",
  "red",
  "green",
  "green",
];

function TpcTrainerJacquesSpotlight({
  applyHref = "https://andus.co.za/trade-register",
  curriculumHref = "#tpc-curriculum-explorer",
}) {
  return (
    <section
      id="tpc-trainer-jacques-spotlight"
      className="trpc-trainerJacques"
      aria-labelledby="trpc-trainerJacques-title"
    >
      <div className="trpc-trainerJacques__shell">
        <div className="trpc-trainerJacques__bridge" aria-hidden="true">
          <span>Trainer Profile 03</span>
          <i />
          <strong>Portfolio strategy</strong>
        </div>

        <div className="trpc-trainerJacques__card">
          <div
            className="trpc-trainerJacques__visual"
            aria-label="Jacques Labuschagne"
          >
            <div className="trpc-trainerJacques__portraitStage">
              <div
                className="trpc-trainerJacques__terminalTop"
                aria-hidden="true"
              >
                <span />
                <span />
                <span />
              </div>

              <div
                className="trpc-trainerJacques__marketPanel"
                aria-hidden="true"
              >
                <span>Market Efficiency</span>
                <strong>JSE</strong>
              </div>

              <div
                className="trpc-trainerJacques__candleStrip"
                aria-hidden="true"
              >
                {marketCandles.map((trend, index) => (
                  <span key={`${trend}-${index}`} data-trend={trend} />
                ))}
              </div>

              <div className="trpc-trainerJacques__imageFrame">
                <img
                  className="trpc-trainerJacques__portrait"
                  src={jacquesImage}
                  alt="Jacques Labuschagne"
                  loading="lazy"
                  decoding="async"
                />
              </div>

              <div className="trpc-trainerJacques__badge trpc-trainerJacques__badge--top">
                <span>Trading lens</span>
                <strong>Risk before return</strong>
              </div>

              <div className="trpc-trainerJacques__badge trpc-trainerJacques__badge--bottom">
                <span>Speciality</span>
                <strong>Financial modelling</strong>
              </div>
            </div>
          </div>

          <div className="trpc-trainerJacques__copy">
            <span className="trpc-trainerJacques__eyebrow">
              Portfolio Strategy & Market Efficiency
            </span>

            <div className="trpc-trainerJacques__nameBlock">
              <h2 id="trpc-trainerJacques-title">Jacques Labuschagne</h2>
              <p>Strategic finance executive · Investment analyst</p>
            </div>

            <p className="trpc-trainerJacques__bio">
              Jacques helps traders think like capital allocators. His strength
              is turning market information, financial modelling and portfolio
              logic into clearer risk decisions.
            </p>

            <p className="trpc-trainerJacques__bio">
              His JSE return-dispersion research and finance background sharpen
              the way learners evaluate opportunity, downside and evidence
              before committing capital.
            </p>

            <div
              className="trpc-trainerJacques__proofGrid"
              aria-label="Jacques trading-relevant proof points"
            >
              {proofPoints.map((item) => {
                const Icon = item.icon;

                return (
                  <article
                    key={item.id}
                    className="trpc-trainerJacques__proof"
                    data-trend={item.trend}
                  >
                    <span
                      className="trpc-trainerJacques__proofIcon"
                      aria-hidden="true"
                    >
                      <Icon size={18} strokeWidth={2.35} />
                    </span>

                    <div>
                      <strong>{item.value}</strong>
                      <span>{item.label}</span>
                    </div>
                  </article>
                );
              })}
            </div>

            <div className="trpc-trainerJacques__focusPanel">
              <div className="trpc-trainerJacques__focusHead">
                <ShieldCheck size={18} strokeWidth={2.35} aria-hidden="true" />
                <h3>What Jacques brings to traders</h3>
              </div>

              <ul>
                {tradingFocus.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="trpc-trainerJacques__actions">
              <a
                className="trpc-trainerJacques__btn trpc-trainerJacques__btn--primary"
                href={applyHref}
                target="_blank"
                rel="noopener noreferrer"
                data-candle="green"
              >
                <span>Train with TPC</span>
                <ArrowUpRight size={17} strokeWidth={2.4} aria-hidden="true" />
              </a>

              <a
                className="trpc-trainerJacques__btn trpc-trainerJacques__btn--secondary"
                href={curriculumHref}
                data-candle="red"
              >
                <span>View Curriculum</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TpcTrainerJacquesSpotlight;